import React from "react";
import { Routes, Route } from "react-router-dom";
import "./Style/Global.css";
import Header from "./Components/Header";
import Home from "./Pages/Home";
import Footer from "./Components/Footer";
import About from "./Pages/About";
import ServiceRequestForm from "./Components/ServiceRequestForm";
import OurProjects from "./Pages/OurProjects";
import ContactUs from "./Pages/Contact";
import PuzzleParkingDetail from "./Pages/Services/PuzzleParking";
import PuzzlePitParkingDetail from "./Pages/Services/PuzzlePitParking";
import FourLevelPitParkingDetail from "./Pages/Services/FourLevelPitParking";
import ThreeLevelParkingDetail from "./Pages/Services/ThreeLevelParking";
import ThreeLevelPitParkingDetail from "./Pages/Services/ThreeLevelPitParking";
import TwoLevelParkingDetail from "./Pages/Services/TwoLevelParking";
import TwoLevelPitParkingDetail from "./Pages/Services/TwoLevelPitParking";
import TowerParkingDetail from "./Pages/Services/TowerParking";
import RotaryParkingDetail from "./Pages/Services/RotaryParking";
import ScrollToTop from "./Components/ScrollToTop";

const App = () => {
  return (
    <>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/get-started" element={<ServiceRequestForm />} />
        <Route path="/projects" element={<OurProjects />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route
          path="/services/puzzle-parking"
          element={<PuzzleParkingDetail />}
        />
        <Route
          path="/services/puzzle-pit-parking"
          element={<PuzzlePitParkingDetail />}
        />
        <Route
          path="/services/4-level-pit-parking"
          element={<FourLevelPitParkingDetail />}
        />
        <Route
          path="/services/3-level-parking"
          element={<ThreeLevelParkingDetail />}
        />
        <Route
          path="/services/3-level-pit-parking"
          element={<ThreeLevelPitParkingDetail />}
        />
        <Route
          path="/services/2-level-parking"
          element={<TwoLevelParkingDetail />}
        />
        <Route
          path="/services/2-level-pit-parking"
          element={<TwoLevelPitParkingDetail />}
        />
        <Route
          path="/services/tower-parking"
          element={<TowerParkingDetail />}
        />
        <Route
          path="/services/rotary-parking"
          element={<RotaryParkingDetail />}
        />
      </Routes>
      <Footer />
    </>
  );
};

export default App;
